import { IPrize } from 'models/types';

export const PRIZES: IPrize[][] = [
 [
  { count: '4 176', price: '4 000' },
  { count: '12 021', price: '2 000' },
  { count: '71 258', price: '1 000' },
  { count: '463 421', price: '400' },
  { count: '2 575 250', price: '200' },
  { count: '2 648 176', price: '100' }
 ],
 [
  { count: '1 000', price: '8 000' },
  { count: '2 000', price: '4 000' },
  { count: '4 000', price: '2 000' },
  { count: '6 000', price: '1 000' },
  { count: '30 000', price: '800' },
  { count: '50 000', price: '600' },
  { count: '200 000', price: '400' },
  { count: '1 100 000', price: '200' },
  { count: '1 460 000', price: '100' }
 ],
 [
  { count: '132', price: '18 000' },
  { count: '1 080', price: '10 000' },
  { count: '2 088', price: '4 000' },
  { count: '4 176', price: '2 000' },
  { count: '31 960', price: '1 000' },
  { count: '222 538', price: '400' },
  { count: '1 269 280', price: '200' },
  { count: '1 324 088', price: '100' }
 ]
];
